export default __webpack_public_path__ + "cc7b7cf2c85e2aadeb3571291357cfb4.webp";